<template>

	<div class="fullwidth bg_main">

		<div class="fullwidth center  padding15">
			<div class="fullwidth center bg_fff radius10 overhide marginb15">
				
				<div class="center automargin padding30">
					<img v-if="user.photo" :src="user.photo" mode="aspectFit"
						@click="selectImg" class="border middle radius50 width150r height150r lineh1 inline center" />
					<div v-else @click="selectImg" class="bg_green2  color5 size80r middle radius50 width150r height150r  inline uni-icon uni-icon-person lineh150r"></div>
					
					<div v-if="!!user.id==true" @click="toUpdateNickName" class="marginl10 color_green1 inline middle">
						{{user.name?user.name:(user.nickName?user.nickName:(user.phone?user.phone:'未填写'))}}
					</div>
					<div v-else @click="toLogin" class="marginl10 color_green1 inline middle">请先登录</div>
				</div>
			

				<div class="flex_row paddingt10 paddingb10 ">
					<div @click="toMyCash" class="center marginr5 flex1 borderr">
						<div>￥{{user.money?user.money:0}}</div>
						<div>余额</div>
					</div>
					<div  @click="toMyJifen" class="center marginr5 flex1 borderr">
						<div>{{user.jifen?user.jifen:0}}</div>
						<div>积分</div>
					</div>
					<div  @click="toMyCoupon" class="center flex1">
						<div>{{user.coupon?user.coupon:0}}</div>
						<div>现金券</div>
					</div>

				</div>
			</div>
		

		

		<!-- 我的订单 -->
			<div class="fullwidth center bg_fff radius10 overhide marginb15 ">
				<div @click="toOrderList" class="flex_row paddingl15 paddingr15 ">
					<div class="flex_row_s autowidth padding0">
						
						<div class="mine_item_text size4">我的订单</div>
					</div>
					<div class="flex_row_s autowidth padding0">
						<div class="mine_item_text size4">全部订单</div>
						<img class="width18 height18" src="@/assets/images/arrow_right.png" mode="cover" />
					</div>
				</div>


				<div class="order flex_row padding0 ">
					<div @click="toOrderList('wait_pay')" class="flex1 item padding10 center relative">
						<img class="inline  width60r height60r" src="@/assets/images/order_wait_pay.png" />
						<div class="size4">待付款</div>
						<div class="label bg_red color5 size5 radius100 center" v-if="orderCountByState.wait_pay">
							{{orderCountByState.wait_pay}}
						</div>
					</div>
					<div @click="toOrderList('wait_send')" class="flex1 item padding10 center relative">
						<img class="inline  width60r height60r" src="@/assets/images/order_wait_peisong.png" />
						<div class="size4">待发货</div>
						<div class="label bg_red color5 size5 radius100 center" v-if="orderCountByState.wait_send">
							{{orderCountByState.wait_send}}
						</div>
					</div>
					<div @click="toOrderList('wait_receive')" class="flex1 item padding10 center relative">
						<img class="inline  width60r height60r" src="@/assets/images/order_peisong.png" />
						<div class="size4">待收货</div>
						<div class="label bg_red color5 size5 radius100 center" v-if="orderCountByState.wait_receive">
							{{orderCountByState.wait_receive}}
						</div>
					</div>
					<div @click="toOrderList('wait_pingjia')" class="flex1  item padding10 center relative">
						<img class="inline  width60r height60r" src="@/assets/images/order_wait_pingjia.png" />
						<div class="size4">待评价</div>
						<div class="label bg_red color5 size5 radius100 center" v-if="orderCountByState.wait_pingjia">
							{{orderCountByState.wait_pingjia}}
						</div>
					</div>

					<!--
					<div bindtap="toOrderList" data-action="6" class="item padding10 center relative ">
					<img class="inline opacity5" src="../../../images/order_wait_refund.png" />
					<div class="fullwidth size5 ellips">退款</div>
					<div class="label bg_red color5 size5 radius100 center" wx:if="{{orderCountByState.e}}">{{orderCountByState.e}}
					</div>
					</div>-->
				</div>
			</div>
		


		

		<!-- 我的服务 -->
			<div class="fullwidth center bg_fff radius10 overhide marginb15">
				<div class="flex_row paddingl15 paddingr15 ">
					<div class="flex_row_s autowidth padding0">
						<img class="hidden item_icon" src="@/assets/images/b4.png" />
						<div class="mine_item_text size4">我的服务</div>
					</div>
				</div>


				<div class="order flex_row padding0 ">



					<div @click="showQrcode" class="flex1 padding10 center ">
						<img class=" width60r height60r  inline" src="@/assets/images/v9.png" />
						<div class=" size4">分享码</div>
					</div>


					<div @click="toAddrList" class="flex1 padding10 center ">
						<img class=" width60r height60r inline" src="@/assets/images/v4.png" />
						<div class="  size4">收货地址</div>
					</div>


					<div @click="toTalkList" class="flex1 padding10 center ">
						<img class=" width60r height60r inline" src="@/assets/images/v8.png" />
						<div class="  size4">我的消息</div>
					</div>


					
					
					<div class=" flex1 padding10 center "> </div>
				</div>

			</div>
		


		</div>

		<!-- <div class="borderb marginb5 flex_row paddingr15 paddingl15" @click="toCoupon">
			<span class=" marginl10 marginr10 flex1 ">现金券</span>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div>

		<div class="borderb marginb5 flex_row paddingr15 paddingl15" @click="toAddrList">
			<span class=" marginl10 marginr10 flex1 ">收货地址</span>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div>

		<div class=" marginb5 flex_row paddingr15 paddingl15">
			<div class="  marginl10 marginr10 flex1 ">我的收藏</div>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div>

		<div class="hidden borderb marginb5 flex_row paddingr15 paddingl15">
			<div class="  marginl10 marginr10 flex1 ">个人资料</div>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div>

		<div class="hidden borderb marginb5 flex_row paddingr15 paddingl15" @click="toPage"
			data-page="/pages/goods/edit">
			<div class="  marginl10 marginr10 flex1 ">编辑商品</div>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div>
		<div class="hidden borderb marginb5 flex_row paddingr15 paddingl15">
			<div class="  marginl10 marginr10 flex1 ">购物车</div>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div>
		<div class="hidden borderb marginb5 flex_row paddingr15 paddingl15" @click="toUniappHelp">
			<div class="  marginl10 marginr10 flex1 ">支持</div>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div>

		<div class="hidden marginb5 flex_row paddingr15 paddingl15" @click="toLogin">
			<span class=" marginl10 marginr10 flex1 ">登录</span>
			<span class="uni-navigate-icon uni-icon color4">&#xe470;</span>
		</div> -->


		<!-- 普通弹窗 -->
		<uni-popup ref="operate_popup" background-color="#fff" @change="popChange">
			<!-- 操作 -->
			<div v-if="popEvent=='operate'"
				class="relative width500r maxwidth500 popup-content padding15 left bg_white radius20r"
				:class="{ 'popup-height': popType === 'left' || popType === 'right' }">
				<div class="fullwidth ">
					<img class="fullwidth autoheight" mode="widthFix" :src="qrcodeUrl" />
					<div class="center margint10">
						<div @click="popClose()"
							class="bg_blue1   size4r inline width150r ">关闭</div>
						<div @click="saveQrcode()"
							class="bg_blue1   size4r inline width150r  marginl15">保存</div>
					</div>
				</div>
			</div>
			
			<!-- 编辑nickname -->
			<div v-if="popEvent=='nickname'"
				class="relative width500r maxwidth500 popup-content padding20 left bg_white "
				:class="{ 'popup-height': popType === 'left' || popType === 'right' }">
				<div class="fullwidth ">
					<div class="center">修改昵称</div>
					<input v-model="nickName" class="border ridius5 fullwidth height40 padding10" placeholder="填写昵称"/>
					<div class="center margint20">
						<div @click="popClose()"
							class="bg_main padding5 radius5 size4r inline width150r ">关闭</div>
						<div @click="updateNickName()"
							class="bg_main padding5 radius5 size4r inline width150r  marginl15">保存</div>
					</div>
				</div>
			</div>
			
		</uni-popup>

	</div>

</template>

<script>
	import jrQrcode from "jr-qrcode"
	import chineseverify from '@/components/chineseverify/chineseverify.vue';
	// #ifdef H5
	import { saveAs } from 'file-saver';
	// #endif
	import uniPopup from '@/components/uni-popup/uni-popup.vue';
	//var app=getApp();

	export default {
		components: {
			chineseverify, uniPopup
		},
		data() {
			return {
				user: {},
				phone: "",
				smsCode: "", //用于证明手机号拥有
				verifyCode: "", //用于证明不是机器操作
				windowHeight: 0,
				chineseverifyImg: "",
				imgBoxTop: 0,
				imgBoxLeft: 0,
				index: 0,
				rightArr: [],
				showPopup: false,
				chineseverifyTitle: "",
				pwPlaceholder: "请填写短信验证码或密码",
				orderCountByState: {},

				hasUserInfo: false,
				//canIUseGetUserInfo: wx.canIUse('button.open-type.getUserInfo'),
				//canIUseGetPhoneNumber: wx.canIUse('button.open-type.getPhoneNumber'),
				isShowMyinfo: false, //是否显示我的资料
				isShowCheckinBox: false,

				isSeller: 0,
				canIUseGetUserProfile: false, //是否支持getUserProfile

				coupon: "0.00",
				popEvent:"",
				
				nickName:"",
				qrcodeUrl:"",
			}
		},
		/**
		uni.$emit、 uni.$on 、 uni.$once 、uni.$off 触发的事件都是 App 全局级别的，跨任意组件，页面，nvue，vue 等
		使用时，注意及时销毁事件监听，比如，页面 onLoad 里边 uni.$on 注册监听，
		onUnload 里边 uni.$off 移除，或者一次性的事件，直接使用 uni.$once 监听
		 */
		created() {
		
			
		
			//this.getVerifyCode("");
		
			// 位置
			// try{
			// 	const query = window.$utils.uniapi.createSelectorQuery();
			// 	query.select('#verifyimg_box').boundingClientRect(data => {
			// 	  console.log("得到布局位置信息" + JSON.stringify(data));
			// 	  console.log("节点离页面顶部的距离为" + data.top);
			// 	  this.imgBoxTop=data.top;
			// 	  this.imgBoxLeft=data.left;
			// 	}).exec();
			// }catch(e){
			// 	console.log(e);
			// }
		
		
		
			// 调用
			// var that=this;
			// setTimeout(function(){
			// 	that.$refs.cnverify_popup.getVerifyCode("");
			// 	},2000
			// 	);
		
		
		
		},
		
		mounted() {
			var that = this;
					
			this.user = window.$utils.uniapi.getStorageSync("user") || {};
			console.log("----------------",this.user);
					
			// window.$utils.uniapi.$on("cancelChineseVerify", function() {
			// 	console.log("......cancelChineseVerify");
			// 	that.showPopup = false;
			// });
					
					
					
			//界面调整位置
			try {
				const res = window.$utils.uniapi.getSystemInfoSync();
				console.log(res);
				this.windowHeight = res.windowHeight;
			} catch (e) {
				window.$utils.uniapi.showToast({ title: e });
			}

			//获取最新金额等
			window.$utils.getUserInfo(that,function(res) {
				that.user = Object.assign(that.user, res);
			});

		},
		
		
		onUnload() {
			// window.$utils.uniapi.$off("cancelChineseVerify");
		},
		onShareAppMessage() {
			return {
				title: '欢迎体验',
				path: '/pages/goods/list/list'
			}
		},
		onNavigationBarButtonTap(e) {
			this.$router.push({ path: '/' }); 
		},
		methods: {
			toPage(e) {
				var page = e.currentTarget.dataset.page;
				this.$router.push({path:page,query:{  }}); 
			},
			toLogin() {

				this.$router.push({ path: "/user_login" });
			},

			doLogin() {
				console.log("doLogin...");
				// this.showPopup=true;
				// this.$refs.cnverify_popup.getVerifyCode("");
				// return;

				var phone = this.phone;
				var smsCode = this.smsCode;
				if (!!phone == false || !!smsCode == false) {
					window.$utils.uniapi.showToast({
						title: "需要手机号和验证码",
						icon: "none"
					});
					return;
				}
				this.$axios.request({
						url: window.$config.url.doLogin,
						data: {
							phone: phone,
							smsCode: smsCode
						}
					})
					.then(res => {
						console.log(res);
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							window.$utils.uniapi.setStorageSync("user", res.data);
							window.$utils.uniapi.showToast({
								title: res.msg,
								icon: "none"
							});
						} else if (!!res.msg == true) {
							window.$utils.uniapi.showToast({
								title: res.msg,
								icon: "none"
							});
						} else {
							window.$utils.uniapi.showToast({
								title: "不成功",
								icon: "none"
							});
						}
					});
			},


			//发送短信验证码
			// sendSmsCode() {
			// 	var that = this;
			// 	this.showPopup = true;
			// 	this.$refs.cnverify_popup.getVerifyCode(this.phone);
			// 	this.chineseverifyTitle = "即将发送短信验证码";

			// 	window.$utils.uniapi.$off("chineseVerifySuccessCallback");
			// 	window.$utils.uniapi.$on("chineseVerifySuccessCallback", function(d) {
			// 		that.showPopup = false;
			// 		console.log(d);

			// 		//发送短信
			// 		that.$axios.request({
			// 				url: window.$config.url.sendSmsCode,
			// 				data: {
			// 					phone: that.phone,
			// 					verifyCode: d.verifyCode
			// 				}
			// 			})
			// 			.then(res => {

			// 				if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
			// 					window.$utils.uniapi.showToast({
			// 						title: res.msg,
			// 						icon: "none"
			// 					});

			// 				} else if (!!res.msg == true) {
			// 					window.$utils.uniapi.showToast({
			// 						title: res.msg,
			// 						icon: "none"
			// 					});
			// 				} else {
			// 					window.$utils.uniapi.showToast({
			// 						title: "不成功",
			// 						icon: "none"
			// 					});
			// 				}
			// 			});
			// 	});


			// },

			inputPhone() {
				var that = this;
				setTimeout(() => {
					console.log()
					if (that.phone.length == 11 && that.phone.match(/^\d+$/)) {
						that.pwPlaceholder = "请填写短信验证码";
					} else {
						that.pwPlaceholder = "请填写短信验证码或密码";
					}
				}, 100);
			},



			toTalkList() {
				window.$utils.uniapi.navigateTo({
					url: "/pages/talk/list/list"
				})
			},

			toAddrList() {
				console.log("toAddrList");
				this.$router.push({path:"/order_addr_list",query:{ action:"from_user" }});
			},

			toCoupon() {

			},



			getOrderCount() {
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (!!user==false || typeof user.id == "undefined") {
					console.log("无用户信息");
					return false;
				}
				var params = {
					mid: user.id
				};
				that.$axios.request({
						url: window.$config.url.getOrderCountByState,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							var orderCountByState = res.data;
							that.orderCountByState = orderCountByState;
						}
					});

			},


			toOrderList(action) {
				if ( !!action==false || typeof action == 'undefined' || action == null ||
					action == 'null' || action == 'undefined' || typeof action!='string'
				) {
					action = '';
				}
				this.$router.push({path:"/order_list",query:{ action:action }}); 
			},

			showQrcode(){
				// this.makeQrcode();return;
				var that=this;
				this.getAdvList(function(d){
					if(d && d.length>0){
						var sj=Math.floor(Math.random()*(d.length-1));
						console.log("sj="+sj);
						var mainImgUrl=d[sj].img;
						that.getShareQrcode(mainImgUrl);
					}
				})
			},
			getAdvList(callback) {
				var that = this;
				var params = {
					position: window.$config.advPosition.index //"xs_wxmp_index_top"
				};
				this.$axios.request({
						url: window.$config.url.getAdvList,
						data: params
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							let list = res.data;
							//this.advList = this.page == 1 ? list : this.advList.concat(list);
							if(typeof callback=='function'){ callback(list);}
						} else if (!!res.msg == true) {
							window.$utils.uniapi.showToast({ title: res.msg, icon: "none" });
						} else {
							window.$utils.uniapi.showToast({ title: "不成功", icon: "none" });
						}
					});

			},
			/**
			 * 前端js直接生成qrcode
			 */
			makeQrcode(){
				if (!!this.user==false || typeof this.user.id == "undefined") {
					alert("请先登录");
					return false;
				}
				var str=window.$config.appHost+"?fromUid="+this.user.id;
				 //生成代码
				this.qrcodeUrl = jrQrcode.getQrBase64(str);//二维码

				//条形码
				// JsBarcode("#barcode", this.pcode, {
				// 	format: "code128",
				// 	lineColor: "#000",
				// 	width:4,
				// 	height:40,
				// 	displayValue: false
				// 	});

				// 显示
				this.popEvent='operate';
				this.$forceUpdate();
				this.popOpen("center");

			},
			getShareQrcode(mainImgUrl) {
				console.log("二维码..."+mainImgUrl);
				var that = this;
				var word="扫码进入 ["+window.$config.appName+"]为您精心准备的健康产品";
				if(window.$config.appName=="礼著"){
					word="爱茶的朋友，欢迎扫码加入我们！一起推广优质岩茶，开启财富新篇章！";
				}
				
				var appType="web";
				// #ifdef MP-WEIXIN
					// appType="wxmp";
				// #endif
				
				try {
					var params = {
						appType: appType, //wxmp,web
						font: "STXihei", //"Microsoft YaHei",//
						scene: "kkkkk,mmmmm",
						env_version: "develop", //要打开的小程序版本。正式版为 "release"，体验版为 "trial"，开发版为 "develop"。默认是正式版。 
						mainImgUrl: mainImgUrl?mainImgUrl:(window.$config.userHost+"/file/upload/adv/adv18.jpg"), //"http://49.235.140.46:6034/file/upload/2024/10/6/1728223622241sdYnfu.jpg",
						word: word ,
						pageUrl:window.$config.appHost+window.$config.appBasePath
					};


					window.$utils.uniapi.showLoading({ title:"请稍等" });
					that.$axios.request({
							url: window.$config.url.getShareQrcode,
							data: params
						})
						.then(res => {
							console.log("ccccc",res);
							that.isLoadFinished = true;
							window.$utils.uniapi.hideLoading();
							if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
								that.qrcodeUrl= res.data;
								
								that.popEvent='operate';
								that.$forceUpdate();
								that.popOpen("center");
							}else if(res.msg){
								console.log("res.msg",res.msg);
								alert(res.msg); 
							}else{
								console.log("res",res);
								alert("没有图片");
							}
						});
				} catch (e) {
					console.log("error ", e);
				}
			},

			popChange(e) {
				console.log('当前模式：' + e.type + ',状态：' + e.show);
			},
			popOpen(type) {
				this.popType = type
				// open 方法传入参数 等同在 uni-popup 组件上绑定 type属性
				this.$refs.operate_popup.open(type);
			},
			popClose() {
				if (this.$refs.operate_popup) this.$refs.operate_popup.close();
			},
			
			
			toUpdateNickName(){
				this.popEvent='nickname';
				this.popOpen("center");
			},
			updateNickName(callback){
				if(!!this.nickName==false){
					window.$utils.uniapi.showToast({ title:"需要昵称",icon:"none" });return;
				}
				var that = this;
				var params = {
					nickName: this.nickName
				};
				this.$axios.request({
						url: window.$config.url.updateNickName,
						data: params
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							window.$utils.uniapi.showToast({ title:"成功",icon:"none" });
							
							this.user.nickName = this.nickName;
							window.$utils.uniapi.setStorageSync("user",this.user);
							
							if(typeof callback=='function'){ callback();}
						} else if (!!res.msg == true) {
							window.$utils.uniapi.showToast({ title: res.msg, icon: "none" });
						} else {
							window.$utils.uniapi.showToast({ title: "不成功", icon: "none" });
						}
					});
			},
			
			
			/**
				1、因为h5端不支持uni.saveFile方法保存文件，要使用js的第三方库来进行保存文件 
				1、安装file-saver：在项目目录中运行命令 npm install file-saver --save 来安装file-saver库
				2、引入file-saver：使用页面import { saveAs } from 'file-saver';引入file-saver库。
				12代码解读 
				2、根据文件地址信息下载保存文件 
				window.$utils.uniapi.downloadFile({
				url: fileUrl,//下载文件的地址
				success: (res) =&gt; {
				if (res.statusCode === 200) {

				// *保存文件到本地
				// *res.tempFilePath：下载好文件的临时路径，用来保存
				// *this.uploadedFile.name：下载的文件名称

				saveAs(res.tempFilePath,this.uploadedFile.name);
				}
				}
				});
			 */
			saveQrcode(){
				console.log("saveQrcode");
				// #ifdef H5
				if(this.qrcodeUrl.startsWith("http")){
					this.h5SaveFileTolocal(this.qrcodeUrl);
				}else{
					this.downloadBase64Image(this.qrcodeUrl);
				}
				return;

				//原fangfa
				//if(window)window.open(this.qrcodeUrl);
				window.$utils.uniapi.downloadFile({
					url: this.qrcodeUrl,//下载文件的地址
					success: (res) => {
						if (res.statusCode === 200) { 
							// *保存文件到本地
							saveAs(res.tempFilePath,window.$config.appName+"-分享二维码");
							window.$utils.uniapi.showToast({
								title:"已保存到本地",icon:"none"
							});
						}
					}
				});
				// #endif
				
				
				// #ifdef MP-WEIXIN
				    // wx.downloadFile({
				    //   url: this.qrcodeUrl,
				    //   success (res) {
				    //     if (res.statusCode === 200) {
				    //       var path=res.tempFilePath;
				
				    //       wx.saveImageToPhotosAlbum({
				    //         filePath: path,
				    //         success: function (data) {
				    //           wx.showToast({
				    //             title: '保存成功',
				    //             icon: 'success',
				    //             duration: 2000
				    //           })
				    //         },
				    //         fail: function (err) {
				    //           console.log(err);
				    //           if (err.errMsg.indexOf("fail auth deny")>0) {
				    //             console.log("当初用户拒绝，再次发起授权")
				    //             wx.openSetting({
				    //               success(settingdata) {
				    //                 console.log(settingdata)
				    //                 if (settingdata.authSetting['scope.writePhotosAlbum']) {
				    //                   console.log('获取权限成功，给出再次点击图片保存到相册的提示。')
				    //                 } else {
				    //                   console.log('获取权限失败，给出不给权限就无法正常使用的提示')
				    //                 }
				    //               }
				    //             })
				    //           }
				    //         },
				    //         complete(res) {
				    //           console.log(res);
				    //         }
				      
				    //       });
				    //     }
				    //   }
				    // })
				// #endif
				
			},
			
			
			//选择头像
			selectImg(){
				if(typeof this.user.id=='undefined'){
					this.toLogin();return;
				}
				var that=this;
				window.$utils.uniapi.chooseImage({
					success: (chooseImageRes) => {
						const tempFilePaths = chooseImageRes.tempFilePaths;
						window.$utils.uniapi.uploadFile({
							url: window.$config.url.uploadFile, 
							filePath: tempFilePaths[0],
							name: 'file',
							formData: {
								'action': 'face'
							},
							success: (uploadFileRes) => {
								console.log(uploadFileRes.data);
								var dd=uploadFileRes.data;
								if(typeof dd=='string')dd=JSON.parse(dd);
								if (!!dd.code == true && dd.code == window.$config.resCode.SUCCESS) {
									that.updatePhoto(dd.data);
								}else{
									window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });return;
								}
							}
						});
					}
				});
			},
			
			//上传头像
			updatePhoto(photo){
					if(!!photo==false){
						window.$utils.uniapi.showToast({ title:"需要图片",icon:"none" });return;
					}
					var that = this;
					var params = {
						photo: photo
					};
					this.$axios.request({
							url: window.$config.url.updatePhoto,
							data: params
						})
						.then(res => {
							if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
								window.$utils.uniapi.showToast({ title:"成功",icon:"none" });
								
								this.user.photo = photo;
								window.$utils.uniapi.setStorageSync("user",this.user);
								
								if(typeof callback=='function'){ callback();}
							} else if (!!res.msg == true) {
								window.$utils.uniapi.showToast({ title: res.msg, icon: "none" });
							} else {
								window.$utils.uniapi.showToast({ title: "不成功", icon: "none" });
							}
						});
				},
					
		/**
			 * Base64字符串转Blob对象
			 * @param {string} base64Data - Base64字符串
			 * @returns {Blob} Blob对象
			 */
			base64ToBlob(base64Data) {
			try {
				// 分离MIME类型和base64数据
				const parts = base64Data.split(';base64,');
				if (parts.length !== 2) {
				throw new Error('Invalid base64 string format');
				}
				
				const contentType = parts[0].split(':')[1];
				const raw = window.atob(parts[1]);
				const rawLength = raw.length;
				const uInt8Array = new Uint8Array(rawLength);
				
				for (let i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
				}
				
				return new Blob([uInt8Array], { type: contentType });
			} catch (error) {
				console.error('Base64 to Blob conversion failed:', error);
				throw error;
			}
			},
			
			/**
			 * 下载Base64图片
			 * @param {string} base64Data - Base64图片数据
			 * @param {string} fileName - 文件名（可选）
			 * @returns {Promise<string>} 下载的文件名
			 */
			downloadBase64Image(base64Data, fileName = '') {
				return new Promise((resolve, reject) => {
					try {
						const blob = this.base64ToBlob(base64Data);
						
						// 自动生成文件名
						let finalFileName = fileName;
						if (!finalFileName) {
							const timestamp = new Date().getTime();
							const extension = blob.type.split('/')[1] || 'png';
							finalFileName = `image_${timestamp}.${extension}`;
						}
						
						// 创建对象URL
						const url = URL.createObjectURL(blob);
						
						// 创建下载链接
						const link = document.createElement('a');
						link.href = url;
						link.download = finalFileName;
						link.style.display = 'none';
						
						// 添加到DOM并触发点击
						document.body.appendChild(link);
						link.click();
						
						// 清理
						setTimeout(() => {
							document.body.removeChild(link);
							URL.revokeObjectURL(url);
						}, 100);
						
						this.$message.success(`图片已保存: ${finalFileName}`);
						resolve(finalFileName);
						} catch (error) {
						this.$message.error('图片保存失败');
						reject(error);
					}
				});
			},

			h5SaveFileTolocal(url){
				try{
					
					const arr = url.split('/');
					const finalFileName = arr[arr.length-1];


					// 创建下载链接
					const link = document.createElement('a');
					link.href = url;
					link.download = finalFileName;
					link.style.display = 'none';
					
					// 添加到DOM并触发点击
					document.body.appendChild(link);
					link.click();
					
					// 清理
					setTimeout(() => {
						document.body.removeChild(link);
						URL.revokeObjectURL(url);
					}, 100);
				} catch (error) {
					console.log(error);
					alert('图片保存失败');
				}
				
			},


			toMyCash(){
				this.$router.push({path:'/user_liushui_list',query:{subject:'cash'}});
			},
			toMyJifen(){
				this.$router.push({path:'/user_liushui_list',query:{subject:'jifen'}});
			},
			toMyCoupon(){
				this.$router.push({path:'/user_liushui_list',query:{subject:'coupon'}});
			},
		}
		
		
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/views/tabbar/user/index.vue